import ArrowDateSelector from './ArrowDateSelector';
import RankingTable from './RankingTable';

import { Tabs } from '@/components';
import { DefaultTabsProps } from '@/components/Tabs';
import { TabType } from '@/components/Types';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { ResponseTapTourneyData } from '@/types/tda';

interface RankingSelectorProps {
  activeTab: TabType;
  tableTabs: DefaultTabsProps['tabs'];
  tourneyData?: ResponseTapTourneyData;
  fixedLateralData?: ResponseTapTourneyData;
  onHandleTableTabsChanges: (tab: TabType) => void;
}

const RankingSelector = ({
  activeTab,
  tableTabs,
  tourneyData,
  onHandleTableTabsChanges,
  fixedLateralData,
}: RankingSelectorProps) => {
  const { isDesktop, isMobile } = useIsDesktop();

  // Determine which position to show based on active tab
  const rankingPosition = fixedLateralData?.posicion;

  return (
    <div className="lg:bg-white lg:rounded-xl">
      {isDesktop && (
        <div className="text-center lg:pt-6">
          <Tabs
            activeTab={activeTab}
            className="mt-2 lg:max-w-none lg:h-[38px] lg:mt-0 lg:justify-center lg:w-full"
            classNameTabs="lg:max-w-[200px]"
            tabs={tableTabs}
            variant="underline"
            onClick={onHandleTableTabsChanges}
          />
        </div>
      )}
      {isMobile && (
        <div className="flex justify-around rounded-sm bg-white w-full py-2">
          <span className="text-[12px] text-[#717077] font-semibold">
            TU POSICIÓN EN EL RANKING
          </span>
          <span className="text-[20px] text-[#3366FF] font-bold">
            {`#${rankingPosition ?? '-'} `}
          </span>
        </div>
      )}
      <ArrowDateSelector fechaCreacion={tourneyData?.fechaCreacion ?? ''} />

      <RankingTable activeTab={activeTab} tourneyData={tourneyData} />
    </div>
  );
};

export default RankingSelector;
